import { Co2Section } from '@/domain/impact-co2/entities/question.entity';
import { translate } from '@/ui/i18n';
import { CateringMealForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/CateringMealForm';
import { TeamMobilityForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/TeamMobilityForm';
import { QuizFormSeparator } from '@/ui/pages/app/components/quiz-panel/co2/components/QuizFormSeparator';
import { ImpactQuestionContext } from '@/ui/pages/app/components/quiz-panel/ImpactQuestionContext';
import { useExternalSubmitAnswer } from '@/ui/pages/external/hooks/useExternalSubmitAnswer';
import { GenericExternalPageVenue } from '@/ui/pages/external/venue/components/GenericExternalPageVenue';

export function Team() {
  return (
    <GenericExternalPageVenue>
      <Form />
    </GenericExternalPageVenue>
  );
}

function Form({ readOnly = false }: { readOnly?: boolean }) {
  const { onDelete, onSubmit, onEdit } = useExternalSubmitAnswer();

  const sector = 'TEAM';

  const panelOpen = !readOnly;
  return (
    <ImpactQuestionContext.Provider
      value={{ panelOpen: panelOpen, hideCompleted: false }}
    >
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.TRANSPORT}`)}
      />
      <TeamMobilityForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.CATERING}`)}
      />
      <CateringMealForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
    </ImpactQuestionContext.Provider>
  );
}
